import { render } from "./AuthLayout.vue?vue&type=template&id=bb2dc1ee"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=bb2dc1ee&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__